import React from "react";

import DefaultLayout from "./common/DefaultLayout";
import { Link } from "react-router-dom";

import {
  setIsExplainedCookie
} from '../repos/cookies';

const ExplainPage = () => {
  setIsExplainedCookie();

  return <DefaultLayout isWide>
    <div className="explain-wrapper">
      <div className="explain-jp">
        出展社バッジの申請のご案内<br/>
        <br/>
        TSO International株式会社では、出展社バッジについても来場者バッジ同様、使用者の情報を登録し、出展社ご自身で印刷していただく必要がございます。<br/>
        「出展社バッジ」申請用ページにて、情報登録を行い出展社バッジの発行を行ってください。<br/>
        <br/>
        ～申請から発行までの流れ～<br/>
        <ol>
          <li>
            出展社<br/>
            出展社バッジ申請用サイトにて必要な枚数分の登録を行ってください。<br/>
            ※枚数の制限はありません。
          </li>
          <li>申請したご利用者宛にメールにて通知が届きます。</li>
          <li>ご利用者ご自身で出展社バッジを印刷してご持参の上、各ホールの出入口付近に設置していますバッジホルダーからホルダーを取って入場してください。</li>
        </ol>
        ※バッジ印刷済みの方は受付不要です。<br/>
        ※ホルダーは来場者と共通のものとなります。<br/>
        ※バッジは会期中11月28日・29日・30日にご使用いただきます。<br/>
        <br/>
        事前に出展社バッジを印刷していないご出展社は、南1ホール出入口にあります「出展社カウンター」へお越しいただき、出展社バッジの登録ならびに印刷を行ってからのご入場となります。<br/>
        南1ホールの「出展社カウンター」は非常に混雑が予想されますため、事前に出展社バッジの登録ならびに印刷をして、ご持参いただきますようお願いいたします。<br/>
        <br/>
        出展社バッジの申請は以下の「出展社バッジを申請する」ボタンをクリックして申請してください。<br/>
        ご不明な点がありましたら、展示会事務局へお問合せください。<br/>

        <div className="text-center mt-3 mb-3">
          <div className="btn entry-btn"><Link to="/login">出展社バッジを申請する</Link></div>
        </div>
      </div>
      {/* <div className="explain-en">
        Exhibitor batch application information<br/>
        <br/>
        In Freedom Group Demo, it is necessary to register the user information for the exhibitor batch as well as the visitor batch, and have the exhibitor himself print it.<br/>
        Please register information on the "Exhibitor Badge" application page.<br/>
        You can apply for 6 exhibitor badges for the first booth and 4 for the second booth. (For details, please refer to the exhibitor manual)<br/>
        <br/>
        To access the exhibitor batch application site, the ID and password used in the "exhibitor information input login page" registered in the "exhibitor information" published on the website are required. Will be.<br/>
        <br/>
        To apply for an exhibitor badge, click the "Apply for exhibitor badge" button below.

        <div className="text-center mt-3 mb-3">
          <div className="btn entry-btn"><Link to="/login">Apply for exhibitor badge</Link></div>
        </div>
      </div>
      <div className="explain-contact row">
        <div className="explain-contact-jp col-6">

          ご不明な点がございましたら事務局へ連絡ください。<br/>
          ----------------------------------------------------------------------<br/>
          【問い合わせ先】<br/>
          株式会社フリーダム・グループ®<br/>
          TEL 03-3433-5881  FAX 03-3433-1998<br/>
          E-Mail：<img className="contact" alt="contact" src={contact} /><br/>
          URL:http://www.free-dom.net/
        </div>
        <div className="explain-contact-en col-6">
          
          If you have any questions, please contact the secretariat.<br/>
          ----------------------------------------------------------------------<br/>
          [Contact]<br/>
          Freedom Group Inc<br/>
          E-Mail：<img className="contact" alt="contact" src={contact} /><br/>
          URL:http://www.free-dom.net/

        </div>
      </div> */}
    </div>
  </DefaultLayout>
}

export default ExplainPage;
